<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  @clear="otherReportForm.farms = []"
                  @change="change"
                  clearable
                  multiple
                  :multiple-limit="1"
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="otherReportForm.farms"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('production.scale_type') }}* </label>
                <br />
                <el-select
                  filterable
                  @change="change"
                  @clear="otherReportForm.typeScale = null"
                  clearable
                  class="select-primary custom-width-select required-typeScale shadow-sm"
                  size="large"
                  v-model="otherReportForm.typeScale"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsScale"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  @change="changeByInterval"
                  filterable
                  @clear="otherReportForm.bySel = null"
                  clearable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="otherReportForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  otherReportForm.bySel &&
                  otherReportForm.bySel != 'week' &&
                  otherReportForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  @change="change"
                  clearable
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  otherReportForm.bySel == 'week' ||
                  otherReportForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @change="change"
                  @clear="otherReportForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="otherReportForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index * 100 + 1"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  otherReportForm.bySel == 'week' &&
                  otherReportForm.year_sel_init
                "
              >
                <el-select
                  @change="change"
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="otherReportForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[
                      otherReportForm.year_sel_init
                    ]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 200 + 2"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  otherReportForm.bySel == 'week' ||
                  otherReportForm.bySel == 'year'
                "
              >
                <el-select
                  @change="change"
                  clearable
                  @clear="otherReportForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="otherReportForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index * 300 + 4"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  otherReportForm.bySel == 'week' &&
                  otherReportForm.year_sel_end
                "
              >
                <el-select
                  @change="change"
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="otherReportForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[otherReportForm.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 400 + 6"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
              <div
                class="col-12 col-md-4 col-xl-2"
                v-if="otherReportForm.farms == 75"
              >
                <!--Demo-->
                <!--<div class="col-12 col-md-4 col-xl-2" v-if="otherReportForm.farms == 3">--><!--Produccion-->
                <l-button
                  wide
                  type="primary"
                  class="btn-filter shadow-sm"
                  style="margin-top: 30px"
                  @click="syncScalesOthers"
                >
                  {{ $t('common_words.synchronize') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
        <template v-if="otherReport">
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                filterable
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                height="500"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                >
                </el-table-column>
                <el-table-column
                  :min-width="120"
                  :label="`${$t('production.weight')} ${' + weightUnit + '}`"
                >
                  <template slot-scope="props">
                    {{ queriedData[props.$index].net_weight }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            >
            </l-pagination>
          </div>
          <br />
          <center v-if="this.tableData.length > 1000">
            <div class="row">
              <div class="col" v-if="isExcel()">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </center>
          <div
            class="row"
            style="padding-right: 13px; padding-left: 13px"
            v-else
          >
            <div class="col" v-if="isPDF()">
              <div class="text-right">
                <button
                  class="btn btn-danger custom-shadow-btn"
                  @click="exportPDF"
                >
                  <em class="fa fa-file-pdf-o"></em>
                  {{ $t('common_words.export_to_pdf') }}
                </button>
              </div>
            </div>
            <div class="col" v-if="isExcel()">
              <div class="text-left">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import Formatter from 'src/class/Formatter';
import Fuse from 'fuse.js';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import configTable from './OtherTable';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().Search,
    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },
    optionsScale() {
      return {
        0: { label: i18n.t('production.cluster'), value: 1 },
        1: { label: i18n.t('production.tray'), value: 4 },
      };
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },
  data() {
    return {
      otherReportForm: {
        bySel: null,
      },
      activeName: '1',
      typedatepicket: 'daterange',
      valueCollapse: null,
      reports: [],
      interval: 'week',
      years: [],
      farms: [],
      weightUnit: 'Kg',
      otherReport: false,
      titleCard: '',
      pagination: {},
      tableColumns: [],
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinDatePicker,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': ['forceRerender', 'setupTable'],
  },

  methods: {
    changeByInterval() {
      this.otherReport = false;
      this.pagination.currentPage = 1;
      this.pagination.perPage = 10;
      this.typedatepicket = this.otherReportForm.bySel;
    },

    change() {
      this.otherReport = false;
      this.pagination.currentPage = 1;
      this.pagination.perPage = 10;
      if (this.otherReportForm.typeScale == 1) this.weightUnit = 'lb';
      else this.weightUnit = 'kg';
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    validate() {
      this.otherReportForm.calendar_sel = this.rangeDate;

      if (
        this.otherReportForm.farms == null ||
        this.otherReportForm.farms.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        this.otherReportForm.typeScale == null ||
        this.otherReportForm.typeScale.length == 0
      ) {
        return this.validationInputsRequired('typeScale');
      } else if (
        (this.otherReportForm.bySel == 'year' &&
          (this.otherReportForm.year_sel_init == null ||
            this.otherReportForm.year_sel_end == null)) ||
        (this.otherReportForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.otherReportForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.otherReportForm.week_sel_init == null &&
        this.otherReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.otherReportForm.year_sel_end == null &&
        this.otherReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.otherReportForm.week_sel_end == null &&
        this.otherReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.otherReportForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.loadOtherReport();
      }
    },

    formatNumberTable(row, column) {
      return typeof row[column.property] === 'string' ||
        row[column.property] instanceof String
        ? row[column.property]
        : Formatter.formatMoney(row[column.property], 3);
    },

    calculateTotalRow(row, index) {
      let total = 0;

      for (const key in row) {
        if (key != 'type' && key != 'bysel') {
          total += row[key];
        }
      }

      this.totals[index] = total;

      return total;
    },

    calculateTotalColumn(column) {
      let total = 0;

      if (column != 'all') {
        this.table_data.forEach((row) => {
          if (row[column]) {
            total += row[column];
          }
        });
      } else {
        this.totals.forEach((elem) => {
          total += elem;
        });
      }

      return total;
    },

    loadData() {
      let data = {
        farms: this.otherReportForm.farms,
        init:
          parseInt(this.otherReportForm.year_sel_init) * 100 +
          parseInt(this.otherReportForm.week_sel_init),
        end:
          parseInt(this.otherReportForm.year_sel_end) * 100 +
          parseInt(this.otherReportForm.week_sel_end),
        bySel: this.otherReportForm.bySel,
        typeScale: this.otherReportForm.typeScale,
      };

      switch (this.otherReportForm.bySel) {
        case 'year':
          data.init = parseInt(this.otherReportForm.year_sel_init);
          data.end = parseInt(this.otherReportForm.year_sel_end);
          break;
        case 'monthrange':
          data.init = parseInt(moment(this.rangeDate[0]).format('YYYYM'));
          data.end = parseInt(moment(this.rangeDate[1]).format('YYYYM'));
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    loadOtherReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'scales/others/reports';
      Axios.saveMaster(data)
        .then((response) => {
          this.tableData = response.data.table_data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          if (this.tableData.length == 0)
            SweetAlert.warning(i18n.t('common_words.selected_record_no_data'));
          else this.otherReport = true;
          this.showHideLoading();
        })
        .catch((error) => {
          SweetAlert.warning(error.response.data.message);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'week';
    },

    isWeekSekRequired() {
      return this.interval == 'week';
    },

    syncScalesOthers() {
      this.showHideLoading(true);
      Axios.getMasters('scales/others/syncScalesOther')
        .then((response) => {
          this.showHideLoading();
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportPDF() {
      let data = this.loadData();
      data.route = 'scales/others/reports/pdf';
      data.name_file = `${i18n.t('production.other_scales_report')}.pdf`;
      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'scales/others/reports/excel';
      data.name_file = `${i18n.t('production.other_scales_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          Axios.getMasters('calendars/getyearsbusiness')
            .then((response1) => {
              this.farms = response.data.data;
              this.years = response1.data;
              this.showHideLoading();
            })
            .catch((error) => this.showMessageErrors(error));
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('scales');
  },

  destroyed() {
    this.deselectedItemOnMenu('scales');
  },
};
</script>
